// extracted by mini-css-extract-plugin
export default {"main":"LinkMenu_main__0c5NL","menu":"LinkMenu_menu__12w4K","header":"LinkMenu_header__STzfu","divider":"LinkMenu_divider__-ABaX"};